/**
 * @fileoverview Componente atomizado para mostrar el mensaje de usuario bloqueado en el inbox.
 * @module BlockedUserMessageMC
 * @category Component - Atom
 * @since 1.0.0
 * @version 2.0.0 - Estilos optimizados, internacionalización y JSDoc completo.
 */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * BlockedUserMessageMC - Componente para mostrar el mensaje de usuario bloqueado en el inbox.
 */
const BlockedUserMessageMC = memo(() => {
  const { t } = useTranslation('InboxMC');
  return (
    <div className="tw-wrapper">
      <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-4 tw-bg-slate-50 tw-border-t tw-border-gray-200">
        <div className="tw-px-5 tw-text-sm tw-text-gray-950 tw-break-words tw-text-center tw-mb-4">
          <p>{t('blocked_user_message')}</p>
        </div>
      </div>
    </div>
  );
});

BlockedUserMessageMC.displayName = 'BlockedUserMessageMC';

export default BlockedUserMessageMC;
